import { createFileRoute } from '@tanstack/react-router'
import { Box, Typography, Container, Button } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";
import { Link } from "@tanstack/react-router";

export const Route = createFileRoute('/maintain')({
  component: MaintenancePage,
})

function MaintenancePage() {
  return (
    <Container maxWidth="md">
      <Box 
        sx={{ 
          textAlign: 'center', 
          py: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3
        }}
      >
        <ConstructionIcon sx={{ fontSize: 80, color: 'warning.main' }} />
        
        <Typography variant="h3" component="h1" gutterBottom>
          System Maintenance
        </Typography>
        
        <Typography variant="h6" color="text.secondary" paragraph>
          Our servers are currently undergoing maintenance or experiencing technical difficulties.
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          We apologize for the inconvenience. Our team is working to resolve the issue as quickly as possible.
        </Typography>
        
        <Box sx={{ mt: 3 }}>
          <Button 
            variant="contained" 
            color="primary" 
            component={Link}
            to="/"
            sx={{ mr: 2 }}
          >
            Go to Home
          </Button>
          <Button 
            variant="outlined"
            onClick={() => window.location.reload()}
          >
            Try Again
          </Button>
        </Box>
      </Box>
    </Container>
  )
}
